/*
 * Module for the topic label modal
 */

define([
  "marionette",
  "jquery",
  "backbone",
  "messaging/messenger",
  "modules/admin/userAdministration/userDetails/touchpointMapDisplay/touchpointMapView",
], function (Marionette, $, Backbone, Messenger, TouchpointMapView) {
  var TouchpointMapController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.touchpointMap = options.touchpointMap;
      this.name = "touchpointMapModule";
      this.isTenantAdmin = false; //boolean representing whether the edited user is a tenant admin
      this._setUpVents();
    },
    show: function (kbId) {
      var list = this.touchpointMap.where({ kbId: kbId });

      if (list.length === 0) {
        var kbTouchpoints = Messenger.reqres.request("fetch:kb:touchpoints", kbId);
        kbTouchpoints.onSynced(function () {
          for (var i = 0; i < kbTouchpoints.length; i++) {
            this.touchpointMap.createUserTouchpoint(
              kbTouchpoints.at(i).get("touchPointId"),
              kbTouchpoints.at(i).get("touchPoint"),
              kbId,
            );
          }

          list = this.touchpointMap.where({ kbId: kbId });
          this._continueShow(list);
        }, this);
      } else {
        this._continueShow(list);
      }
    },
    _continueShow: function (list) {
      var collection = new Backbone.Collection(list);

      //check if the edited user is a tenant admin. If so, then make it look like all the touchpoints
      //are enabled and disable the checkboxes from being edited.
      collection.isTenantAdmin = this.isTenantAdmin;

      this.view = new TouchpointMapView.touchpointMapView({ collection: collection });

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.view.on(
        "click:touchpoint",
        function (touchpointId) {
          var model = this.touchpointMap.findWhere({ touchpointId: +touchpointId });
          model.set("hasPermissions", !model.get("hasPermissions"));
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _showSubViews: function () {},
    _setUpVents: function () {
      //Whenever a different KB is selected, we re-initialize the show method,
      //with the new KB.  This will refresh the module appropriately.
      Messenger.vent.on(
        "change:selected:kb",
        function (newKbId) {
          //save old stuff
          //display new stuff
          this.touchpointMap.onSynced(function () {
            this.show(newKbId);
          }, this);
        },
        this,
      );

      //Register when the edited user has the tenant admin property changed
      //Also called when the user details modal first loads, in which case this
      //module may not be shown yet.
      Messenger.vent.on(
        "changed:edited:user:tenant:admin",
        function (isTenantAdmin) {
          this.isTenantAdmin = isTenantAdmin;
          if (this.view) {
            this.view.collection.isTenantAdmin = isTenantAdmin;
            this.view.render();
          }
        },
        this,
      );
    },
  });

  return TouchpointMapController;
});
